import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

export const LANGS = [
  { code: "fr", label: "Français" },
  { code: "gcf", label: "Kreyòl" },
  { code: "en", label: "English" },
];

const dict = {
  fr: {
    "app.tagline": "Annuaire de spécialistes pour enfants en Guadeloupe",
    "hero.title": "Trouvez le bon spécialiste pour votre enfant",
    "hero.subtitle": "Des professionnels vérifiés, avec une disponibilité réellement à jour. Orthophonie, psychomotricité, SESSAD et plus, partout en Guadeloupe.",
    "prototype.banner": "Version prototype — les fiches marquées « Exemple » sont des données de démonstration.",
    "search.placeholder": "Nom, spécialité, mot-clé…",
    "filters.button": "Filtres",
    "filters.commune": "Commune",
    "filters.specialty": "Spécialité",
    "filters.availability": "Disponibilité",
    "filters.all": "Toutes",
    "filters.all.m": "Tous",
    "filters.clear": "Effacer les filtres",
    "status.disponible": "Disponible",
    "status.liste_attente": "Liste d'attente",
    "status.complet": "Complet",
    "status.a_confirmer": "À confirmer",
    "specialty.orthophoniste": "Orthophoniste",
    "specialty.psychomotricien": "Psychomotricien·ne",
    "specialty.ergotherapeute": "Ergothérapeute",
    "specialty.psychologue": "Psychologue",
    "specialty.pedopsychiatre": "Pédopsychiatre",
    "specialty.neuropediatre": "Neuropédiatre",
    "specialty.orthoptiste": "Orthoptiste",
    "specialty.educateur_specialise": "Éducateur·rice spécialisé·e",
    "specialty.aba_comportementaliste": "ABA / Comportementaliste",
    "specialty.sessad": "SESSAD",
    "card.updated": "Mis à jour le",
    "card.call": "Appeler",
    "card.contact": "Contacter",
    "card.report": "Signaler une info incorrecte",
    "card.example": "Exemple",
    "card.places": "{a} place(s) restante(s)",
    "card.wait": "Attente estimée : {w}",
    "pro.places": "Places restantes",
    "pro.places.total": "Capacité totale",
    "pro.wait": "Attente estimée (ex : 2-3 mois)",
    "card.languages": "Langues",
    "results.count.one": "1 professionnel trouvé",
    "results.count.other": "{n} professionnels trouvés",
    "results.empty": "Aucun professionnel ne correspond à votre recherche.",
    "report.title": "Signaler une information incorrecte",
    "report.subtitle": "Votre signalement sera transmis à l'équipe Lantouraj.",
    "report.message": "Qu'est-ce qui est incorrect ?",
    "report.contact": "Votre contact (facultatif)",
    "report.submit": "Envoyer le signalement",
    "report.success": "Merci, votre signalement a bien été envoyé.",
    "contact.title": "Contacter",
    "contact.name": "Votre nom",
    "contact.coord": "Votre téléphone ou email",
    "contact.message": "Votre message",
    "contact.submit": "Envoyer le message",
    "contact.success": "Votre message a été envoyé au professionnel.",
    "contact.disclaimer": "Vos coordonnées sont transmises au professionnel uniquement. Aucune donnée médicale concernant votre enfant n'est conservée.",
    "nav.login": "Espace pro",
    "nav.logout": "Déconnexion",
    "nav.admin": "Admin",
    "nav.home": "Annuaire",
    "login.title": "Espace professionnel",
    "login.subtitle": "Gérez votre fiche et votre disponibilité.",
    "login.tab.login": "Connexion",
    "login.tab.register": "Créer un compte",
    "login.email": "Email",
    "login.password": "Mot de passe",
    "login.name": "Nom complet",
    "login.phone": "Téléphone",
    "login.submit": "Se connecter",
    "login.register.submit": "Créer mon compte",
    "login.register.notice": "Votre fiche sera publiée après validation par l'équipe Lantouraj.",
    "login.error": "Identifiants invalides ou compte verrouillé temporairement.",
    "pro.title": "Mon espace professionnel",
    "pro.pending": "Votre fiche est en attente de validation par l'équipe Lantouraj.",
    "pro.status.title": "Ma disponibilité",
    "pro.status.hint": "Un clic suffit. Sans mise à jour pendant {n} jours, votre statut passe en « À confirmer ».",
    "pro.status.updated": "Disponibilité mise à jour.",
    "pro.profile.title": "Ma fiche",
    "pro.profile.note": "Présentation / spécialisations",
    "pro.profile.save": "Enregistrer",
    "pro.profile.saved": "Fiche enregistrée.",
    "admin.title": "Administration",
    "admin.tab.pros": "Professionnels",
    "admin.tab.reports": "Signalements",
    "admin.pending": "En attente",
    "admin.approve": "Approuver",
    "admin.add": "Ajouter un professionnel",
    "admin.edit": "Modifier",
    "admin.delete": "Supprimer",
    "admin.nudge": "Relancer",
    "admin.nudged": "Email de relance envoyé.",
    "admin.stale": "À confirmer",
    "admin.save": "Enregistrer",
    "admin.saved": "Enregistré.",
    "admin.reports.empty": "Aucun signalement.",
    "admin.resolve": "Marquer traité",
    "admin.resolved": "Traité",
    "admin.invite": "Inviter par email",
    "admin.invite.placeholder": "Email du professionnel",
    "admin.invited": "Invitation envoyée.",
    "admin.import": "Importer CSV",
    "admin.import.result": "{n} fiches importées ({e} erreurs).",
    "admin.consent": "Consentement reçu",
    "admin.consent.on": "Consentement le",
    "admin.consent.none": "Pas de consentement",
    "login.invited": "Vous avez été invité·e à rejoindre Lantouraj. Complétez votre inscription ci-dessous.",
    "register.consent": "J'accepte que mes informations professionnelles (nom, spécialité, commune, coordonnées) soient publiées dans l'annuaire Lantouraj.",
    "login.forgot": "Mot de passe oublié ?",
    "login.show_password": "Afficher ou masquer le mot de passe",
    "login.forgot.submit": "Envoyer le lien de réinitialisation",
    "login.forgot.sent": "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé (valable 1 h).",
    "reset.title": "Nouveau mot de passe",
    "reset.submit": "Réinitialiser le mot de passe",
    "reset.success": "Mot de passe mis à jour. Vous pouvez vous connecter.",
    "form.required": "Ce champ est requis",
    "generic.error": "Une erreur est survenue. Réessayez.",
    "footer.privacy": "Aucune donnée médicale concernant les enfants n'est collectée. Les données des professionnels sont affichées avec leur consentement.",
    "footer.legal": "Confidentialité & mentions légales",
    "footer.contact": "Contact",
  },
  gcf: {
    "app.tagline": "Lis espésyalis pou timoun an Gwadloup",
    "hero.title": "Jwenn bon espésyalis la pou timoun-w la",
    "hero.subtitle": "Pwofesyonèl verifyé, ké disponibilité ki ajou toutjou. Òtofoni, sikomotrisité, SESSAD épi plis, partou an Gwadloup.",
    "prototype.banner": "Vèsyon èsè — fis ki maké « Exemple » sé dédone pou démonstwasyon.",
    "search.placeholder": "Non, espésyalité, mo…",
    "filters.button": "Filt",
    "filters.commune": "Komin",
    "filters.specialty": "Espésyalité",
    "filters.availability": "Disponibilité",
    "filters.all": "Tout",
    "filters.all.m": "Tout",
    "filters.clear": "Éfasé filt yo",
    "status.disponible": "Disponib",
    "status.liste_attente": "Lis datant",
    "status.complet": "Konplè",
    "status.a_confirmer": "Pou konfimé",
    "specialty.orthophoniste": "Òtofonis",
    "specialty.psychomotricien": "Sikomotrisyen(n)",
    "specialty.ergotherapeute": "Érgotérapèt",
    "specialty.psychologue": "Sikològ",
    "specialty.pedopsychiatre": "Pédopsikyat",
    "specialty.neuropediatre": "Néwopédyat",
    "specialty.orthoptiste": "Òtoptis",
    "specialty.educateur_specialise": "Édikatris/Édikatè spésyalizé",
    "specialty.aba_comportementaliste": "ABA / Konpòtemantal",
    "specialty.sessad": "SESSAD",
    "card.updated": "Korijé lè",
    "card.call": "Kélé",
    "card.contact": "Kontakté",
    "card.report": "Siyalé on erè",
    "card.example": "Exemple",
    "card.places": "{a} plas ki rété",
    "card.wait": "Lité attant : {w}",
    "pro.places": "Plas ki rété",
    "pro.places.total": "Kapasité total",
    "pro.wait": "Lité attant (ègzanp : 2-3 mwa)",
    "card.languages": "Lang",
    "results.count.one": "1 pwofesyonèl jwenn",
    "results.count.other": "{n} pwofesyonèl jwenn",
    "results.empty": "Pa ni pwofesyonèl ki kòwèsponn ké chèché-w la.",
    "report.title": "Siyalé on enfòmasyon ki pa kòwèk",
    "report.subtitle": "Siyalman-w la kay voyé ba ékip Lantouraj la.",
    "report.message": "Sa ki pa kòwèk ?",
    "report.contact": "Kontak-w (pa obligatwa)",
    "report.submit": "Voyé siyalman an",
    "report.success": "Mèsi, siyalman-w la voyé byen.",
    "contact.title": "Kontakté",
    "contact.name": "Non-w",
    "contact.coord": "Téléfonn oben imèl-ou",
    "contact.message": "Mesaj-ou",
    "contact.submit": "Voyé mesaj la",
    "contact.success": "Mesaj-ou voyé ba pwofesyonèl la.",
    "contact.disclaimer": "Kontak-ou voyé ba pwofesyonèl la sèlman. Pyès dédone médikal asou timoun-w la pa gardé.",
    "nav.login": "Lespas pwo",
    "nav.logout": "Dékonekté",
    "nav.admin": "Admin",
    "nav.home": "Anouwè",
    "login.title": "Lespas pwofesyonèl",
    "login.subtitle": "Jéré fis-ou épi disponibilité-w.",
    "login.tab.login": "Koneksyon",
    "login.tab.register": "Kriyé on kont",
    "login.email": "Imèl",
    "login.password": "Mo dé pas",
    "login.name": "Non konplè",
    "login.phone": "Téléfonn",
    "login.submit": "Konekté kò-w",
    "login.register.submit": "Kriyé kont mwen",
    "login.register.notice": "Fis-ou kay pibliyé apwé validasyon ékip Lantouraj la.",
    "login.error": "Idantifyan pa bon oben kont bloké pou on moman.",
    "pro.title": "Lespas pwofesyonèl mwen",
    "pro.pending": "Fis-ou ap tann validasyon ékip Lantouraj la.",
    "pro.status.title": "Disponibilité mwen",
    "pro.status.hint": "On sèl klik ase. San mizajou pannan {n} jou, stati-ou kay pasé « Pou konfimé ».",
    "pro.status.updated": "Disponibilité mizajou.",
    "pro.profile.title": "Fis mwen",
    "pro.profile.note": "Prezantasyon / espésyalizasyon",
    "pro.profile.save": "Anrejistré",
    "pro.profile.saved": "Fis anrejistré.",
    "admin.title": "Administrasyon",
    "admin.tab.pros": "Pwofesyonèl",
    "admin.tab.reports": "Siyalman",
    "admin.pending": "Ap tann",
    "admin.approve": "Apouwé",
    "admin.add": "Ajouté on pwofesyonèl",
    "admin.edit": "Modifyé",
    "admin.delete": "Sipwimé",
    "admin.nudge": "Woulanmésé",
    "admin.nudged": "Imèl woulanmès la voyé.",
    "admin.stale": "Pou konfimé",
    "admin.save": "Anrejistré",
    "admin.saved": "Anrejistré.",
    "admin.reports.empty": "Pa ni siyalman.",
    "admin.resolve": "Maké twété",
    "admin.resolved": "Twété",
    "admin.invite": "Envité pa imèl",
    "admin.invite.placeholder": "Imèl pwofesyonèl la",
    "admin.invited": "Envitasyon an voyé.",
    "admin.import": "Enpòté CSV",
    "admin.import.result": "{n} fis enpòté ({e} erè).",
    "admin.consent": "Konsantman resivwa",
    "admin.consent.on": "Konsantman lè",
    "admin.consent.none": "Pa ni konsantman",
    "login.invited": "Yo envité-w sou Lantouraj. Konplété enskripsyon-w anba.",
    "register.consent": "Mwen aksèpté pou enfòmasyon pwofesyonèl mwen (non, espésyalité, komin, kontak) parèt nan anouwè Lantouraj la.",
    "login.forgot": "Mo dé pas oubliyé ?",
    "login.show_password": "Montré oben kaché mo dé pas la",
    "login.forgot.submit": "Voyé lyen réinisyalizasyon an",
    "login.forgot.sent": "Si ni on kont pou imèl sa a, on lyen fenk voyé (li bon pannan 1 è).",
    "reset.title": "Nouvo mo dé pas",
    "reset.submit": "Réinisyalisé mo dé pas la",
    "reset.success": "Mo dé pas mizajou. Ou pé konekté kò-w.",
    "form.required": "Chan sa a obligatwa",
    "generic.error": "Ni on erè. Eséyé anko.",
    "footer.privacy": "Pyès dédone médikal asou timoun yo pa ramasé. Dédone pwofesyonèl yo afiché épi konsantman-yo.",
    "footer.legal": "Konfidansyalité épi mansyon légal",
    "footer.contact": "Kontak",
  },
  en: {
    "app.tagline": "Directory of child specialists in Guadeloupe",
    "hero.title": "Find the right specialist for your child",
    "hero.subtitle": "Verified professionals with genuinely up-to-date availability. Speech therapy, psychomotor therapy, SESSAD and more, across Guadeloupe.",
    "prototype.banner": "Prototype version — listings marked “Example” are demo data.",
    "search.placeholder": "Name, specialty, keyword…",
    "filters.button": "Filters",
    "filters.commune": "Commune",
    "filters.specialty": "Specialty",
    "filters.availability": "Availability",
    "filters.all": "All",
    "filters.all.m": "All",
    "filters.clear": "Clear filters",
    "status.disponible": "Available",
    "status.liste_attente": "Waitlist",
    "status.complet": "Full",
    "status.a_confirmer": "To confirm",
    "specialty.orthophoniste": "Speech therapist",
    "specialty.psychomotricien": "Psychomotor therapist",
    "specialty.ergotherapeute": "Occupational therapist",
    "specialty.psychologue": "Psychologist",
    "specialty.pedopsychiatre": "Child psychiatrist",
    "specialty.neuropediatre": "Developmental pediatrician",
    "specialty.orthoptiste": "Orthoptist",
    "specialty.educateur_specialise": "Special educator",
    "specialty.aba_comportementaliste": "ABA / Behavioral therapist",
    "specialty.sessad": "SESSAD",
    "card.updated": "Updated on",
    "card.call": "Call",
    "card.contact": "Contact",
    "card.report": "Report incorrect info",
    "card.example": "Example",
    "card.places": "{a} place(s) left",
    "card.wait": "Estimated wait: {w}",
    "pro.places": "Places left",
    "pro.places.total": "Total capacity",
    "pro.wait": "Estimated wait (e.g. 2-3 months)",
    "card.languages": "Languages",
    "results.count.one": "1 professional found",
    "results.count.other": "{n} professionals found",
    "results.empty": "No professionals match your search.",
    "report.title": "Report incorrect information",
    "report.subtitle": "Your report will be sent to the Lantouraj team.",
    "report.message": "What is incorrect?",
    "report.contact": "Your contact (optional)",
    "report.submit": "Send report",
    "report.success": "Thank you, your report has been sent.",
    "contact.title": "Contact",
    "contact.name": "Your name",
    "contact.coord": "Your phone or email",
    "contact.message": "Your message",
    "contact.submit": "Send message",
    "contact.success": "Your message was sent to the professional.",
    "contact.disclaimer": "Your contact details are shared with the professional only. No medical data about your child is stored.",
    "nav.login": "Pro space",
    "nav.logout": "Log out",
    "nav.admin": "Admin",
    "nav.home": "Directory",
    "login.title": "Professional space",
    "login.subtitle": "Manage your listing and availability.",
    "login.tab.login": "Log in",
    "login.tab.register": "Create account",
    "login.email": "Email",
    "login.password": "Password",
    "login.name": "Full name",
    "login.phone": "Phone",
    "login.submit": "Log in",
    "login.register.submit": "Create my account",
    "login.register.notice": "Your listing will be published after review by the Lantouraj team.",
    "login.error": "Invalid credentials or temporarily locked account.",
    "pro.title": "My professional space",
    "pro.pending": "Your listing is awaiting review by the Lantouraj team.",
    "pro.status.title": "My availability",
    "pro.status.hint": "One tap is enough. Without an update for {n} days, your status switches to “To confirm”.",
    "pro.status.updated": "Availability updated.",
    "pro.profile.title": "My listing",
    "pro.profile.note": "Bio / specializations",
    "pro.profile.save": "Save",
    "pro.profile.saved": "Listing saved.",
    "admin.title": "Administration",
    "admin.tab.pros": "Professionals",
    "admin.tab.reports": "Reports",
    "admin.pending": "Pending",
    "admin.approve": "Approve",
    "admin.add": "Add a professional",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.nudge": "Nudge",
    "admin.nudged": "Nudge email sent.",
    "admin.stale": "To confirm",
    "admin.save": "Save",
    "admin.saved": "Saved.",
    "admin.reports.empty": "No reports.",
    "admin.resolve": "Mark resolved",
    "admin.resolved": "Resolved",
    "admin.invite": "Invite by email",
    "admin.invite.placeholder": "Professional's email",
    "admin.invited": "Invitation sent.",
    "admin.import": "Import CSV",
    "admin.import.result": "{n} listings imported ({e} errors).",
    "admin.consent": "Consent received",
    "admin.consent.on": "Consent on",
    "admin.consent.none": "No consent",
    "login.invited": "You've been invited to join Lantouraj. Complete your registration below.",
    "register.consent": "I agree that my professional information (name, specialty, commune, contact details) will be published in the Lantouraj directory.",
    "login.forgot": "Forgot password?",
    "login.show_password": "Show or hide password",
    "login.forgot.submit": "Send reset link",
    "login.forgot.sent": "If an account exists for this email, a reset link has just been sent (valid for 1 hour).",
    "reset.title": "New password",
    "reset.submit": "Reset password",
    "reset.success": "Password updated. You can log in.",
    "form.required": "This field is required",
    "generic.error": "Something went wrong. Please try again.",
    "footer.privacy": "No medical data about children is collected. Professional data is displayed with their consent.",
    "footer.legal": "Privacy & legal notice",
    "footer.contact": "Contact",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lantouraj_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("lantouraj_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key, vars) => {
    let s = (dict[lang] && dict[lang][key]) || dict.fr[key] || key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
